import React from "react";
import Image from "next/image";
import styles from "./StatsCard.module.css";

interface StatsCardProps {
  icon?: string;
  iconAlt?: string;
  title: string;
  chartData?: string;
  stats?: {
    number: string;
    percentage: string;
    arrowIcon?: string;
    arrowAlt?: string;
  };
  className?: string;
}

export default function StatsCard({
  icon,
  iconAlt = "Icon",
  title,
  chartData,
  stats,
  className = "",
}: StatsCardProps) {
  return (
    <div className={`${styles['stats-card']} ${className}`}>
      {icon && (
        <Image
          src={icon}
          alt={iconAlt}
          className={`${styles['icon-above-card']} ${styles['icon-left']}`}
          width={40}
          height={40}
          loading="lazy"
          decoding="async"
        />
      )}
      <h3>{title}</h3>
      
      {chartData && (
        <div className={styles['growth-chart']}>
          <svg
            viewBox="0 0 400 210"
            className={styles['wave-svg']}
            width="100%"
            height="100%"
            preserveAspectRatio="xMidYMid meet"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-labelledby="growth-chart-title"
          >
            <title id="growth-chart-title">Biểu đồ tăng trưởng</title>
            <path
              d={chartData}
              className={styles['wave-path']}
            />
          </svg>
        </div>
      )}
      
      {stats && (
        <div className={styles['stats-info']}>
          <Image
            src="/assets/sdtc-image/icon/dotred.svg"
            alt="Chấm đỏ thống kê"
            className={styles['stats-icon']}
            width={8}
            height={8}
            loading="lazy"
            decoding="async"
          />
          <span className={styles['stats-number']}>{stats.number}</span>

          <Image
            src="/assets/sdtc-image/icon/dotblue.svg"
            alt="Chấm xanh thống kê"
            className={styles['stats-icon']}
            width={8}
            height={8}
            loading="lazy"
            decoding="async"
          />
          <span className={styles['stats-percentage']}>
            {stats.percentage}
            {stats.arrowIcon && (
              <Image
                src={stats.arrowIcon}
                alt={stats.arrowAlt || "Mũi tên tăng trưởng"}
                className={`${styles['stats-icon']} ${styles['stats-icon-arrow']}`}
                width={12}
                height={12}
                loading="lazy"
                decoding="async"
              />
            )}
          </span>
        </div>
      )}
    </div>
  );
}